import React, { useEffect } from "react";
import { useOutsideClick } from "../common/useOutsideClick";
import logo from "../../assets/logo_white.svg";
import { NXCross } from "../../icons";
import MenuItems from "./MenuItems";
import { useLocation } from "react-router-dom";

function MobileMenu({
  sidebarMobile,
  setSidebarMobile,
}: {
  sidebarMobile: boolean;
  setSidebarMobile: React.Dispatch<React.SetStateAction<boolean>>;
}) {

  const location = useLocation()

  const toggleSideBar = () => {
    setSidebarMobile(true);
  };
  const ref = useOutsideClick(() => setSidebarMobile(true));

  useEffect(()=>{
    toggleSideBar()
  }, [location])
  return (
    <div
      className={`overflow-auto fixed mh:hidden transition-all ease-linear  h-screen top-0 left-0 bg-white z-50 border-r border-[#EEEFF2] 
      ${!sidebarMobile ? 'w-[230px]' : 'w-0 overflow-hidden'}
        `}
      ref={ref}
    >
      {/* <aside className="w-[18%] h-screen sticky top-0 overflow-hidden border-r border-[#EEEFF2]"> */}
      <div className="flex items-center justify-between">
        {!sidebarMobile ? (
          <img
            src={logo}
            alt="NXTBN logo"
            className="w-[150px] mh:w-[170px] my-7 mx-5 p-2 bg-[rgb(39,114,0)] rounded-full"
          />
        ) : (
          <p></p>
        )}
        <button
          className="mh:hidden mr-5 text-black w-5"
          onClick={toggleSideBar}
        >
          <NXCross />
        </button>
      </div>
      <p className="px-5 pb-2 text-base-200 text-[12px]">MENU</p>
      <MenuItems sidebarOpen={sidebarMobile} setSidebarOpen={setSidebarMobile}/>
    </div>
  );
}

export default MobileMenu;
